/**
 * Cliente API de suspensiones POR CASA (Sprint 19a — Suspensiones-rediseño,
 * Opción B). Máquina de estados operada por el tesorero; comisión y tesorero
 * leen. El actor de cada transición lo deriva el backend del JWT (no se
 * envía en el body).
 *
 * Al confirmar el corte/reconexión el sistema opera el WiFi en eWeLink; la
 * citofonía la opera el tesorero en la central desde Reprogramación.
 */
import { apiFetch } from './client';
import type {
  AccesoTipo,
  CandidatoSuspensionRead,
  ReprogramacionPendienteRead,
  SuspenderCasaPayload,
  SuspensionLoteRead,
  SuspensionVigenteRead,
} from './types';

// Tab 1: candidatos a suspensión (nivel EN VIVO, no del snapshot diario).
export function listarCandidatosSuspension(): Promise<
  CandidatoSuspensionRead[]
> {
  return apiFetch<CandidatoSuspensionRead[]>('/suspensiones-lote/candidatos');
}

// Tab 2: suspensiones vigentes/en proceso + orden de trabajo de HW.
export function listarSuspensionesVigentes(): Promise<
  SuspensionVigenteRead[]
> {
  return apiFetch<SuspensionVigenteRead[]>('/suspensiones-lote/vigentes');
}

// Tab 3: accesos a reprogramar en el HW por cambio de dato del vecino.
export function listarReprogramaciones(): Promise<
  ReprogramacionPendienteRead[]
> {
  return apiFetch<ReprogramacionPendienteRead[]>(
    '/suspensiones-lote/reprogramaciones',
  );
}

// El tesorero confirma que ya actualizó el HW → snapshot al día.
// `tipoTrabajo` es el que mostraba la lista: si la casa cambió de estado
// entremedio, el backend responde 409 en vez de registrar otra cosa.
export function marcarReprogramado(
  tipo: AccesoTipo,
  accesoId: string,
  tipoTrabajo: ReprogramacionPendienteRead['tipo_trabajo'],
): Promise<void> {
  return apiFetch<void>(
    `/suspensiones-lote/reprogramaciones/${tipo}/${accesoId}/marcar-reprogramado?tipo_trabajo=${tipoTrabajo}`,
    { method: 'POST' },
  );
}

// Transición 1: suspender la casa (→ en_proceso_suspension).
export function suspenderCasa(
  loteId: string,
  payload: SuspenderCasaPayload,
): Promise<SuspensionLoteRead> {
  return apiFetch<SuspensionLoteRead>(
    `/suspensiones-lote/casa/${loteId}/suspender`,
    { method: 'POST', body: JSON.stringify(payload) },
  );
}

// Transición 2: confirmar el corte (en_proceso_suspension → suspendido).
export function confirmarSuspension(
  suspensionId: string,
): Promise<SuspensionLoteRead> {
  return apiFetch<SuspensionLoteRead>(
    `/suspensiones-lote/${suspensionId}/confirmar-suspension`,
    { method: 'POST' },
  );
}

// Transición 3: reactivar (suspendido → en_proceso_reactivacion).
export function reactivarCasa(
  suspensionId: string,
  payload: SuspenderCasaPayload,
): Promise<SuspensionLoteRead> {
  return apiFetch<SuspensionLoteRead>(
    `/suspensiones-lote/${suspensionId}/reactivar`,
    { method: 'POST', body: JSON.stringify(payload) },
  );
}

// Transición 4: confirmar la reconexión (en_proceso_reactivacion → activo).
export function confirmarReactivacion(
  suspensionId: string,
): Promise<SuspensionLoteRead> {
  return apiFetch<SuspensionLoteRead>(
    `/suspensiones-lote/${suspensionId}/confirmar-reactivacion`,
    { method: 'POST' },
  );
}
